import { useEffect } from 'react';
import { CommonLayout, ConfigLayoutUsers, ListViewLayout } from 'components/layouts';
import { Notify } from 'components/core';
import { useRecoilState } from 'recoil';
import { usersState, currentUserState } from 'states';
import { useUserService } from 'services';
import { useListStatus } from 'molecules/listState/useListStatus';
import { ENTITY_TYPE } from '../../../constants';
import styles from './UsersHome.module.css';

export const UsersHome = () => {
  const [users, setUsers] = useRecoilState(usersState);
  const [currentUser, setCurrentUser] = useRecoilState(currentUserState);
  const userService = useUserService();
  const { status, track } = useListStatus();
  const isSelected = Object.keys(currentUser).length > 0;

  // Reset to overview on every mount — prevents stale user detail showing on nav click
  useEffect(() => {
    setCurrentUser({} as any);
  }, []);

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = () => {
    track(userService.getUsers(true)).then(
      (response: any) => {
        if (response.length > 0) setUsers(response);
      },
      (error: any) => Notify.error(error)
    );
  };

  return (
    <CommonLayout>
      <div className={styles.pageArea}>
        <div className={isSelected ? styles.hidden : styles.fullWidth}>
          <ListViewLayout
            listItems={users}
            showFloatingBtn={true}
            btnText="Add User"
            itemType={ENTITY_TYPE.USER}
            status={status}
            onRetry={getUsers}
          />
        </div>
        {isSelected && (
          <div className={styles.fullWidth}>
            <ConfigLayoutUsers />
          </div>
        )}
      </div>
    </CommonLayout>
  );
};
